export const BREAKPOINTS = {
  mobile: '(max-width: 499px)',
  tablet: '(max-width: 719px)',
  laptop: '(max-width: 1023px)',
  desktop: '(max-width: 1239px)'
};
